import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Page } from '../models';

export type TierAuthorizationStatus =
  'PENDING' |
  'AUTHORIZED' |
  'DECLINED';

export interface TierAuthorizationHistory {
  id: number;
  tierId: number;
  tierName: string;
  tierType: string;
  requesterCommercialId: number;
  requesterCommercialName: string;
  approverCommercialId: number;
  approverCommercialName: string;
  requesterSalesForceId: number;
  requesterSalesForceName: string;
  approverSalesForceId: number;
  approverSalesForceName: string;
  siteId: number;
  siteName: string;
  status: TierAuthorizationStatus;
  createdAt: string;
  respondedAt: string;
}

@Injectable()
export class TierAuthorizationService {

  authorizationUrl =
    environment.dns + 'api/tier-authorizations/';

  constructor(private http: HttpClient) {
  }

  getHistory(
    page: number,
    size: number
  ): Observable<Page<TierAuthorizationHistory>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    return this.http.get<Page<TierAuthorizationHistory>>(
      this.authorizationUrl + 'history',
      { params }
    );
  }
}
